export default __webpack_public_path__ + "images/XV.27b6cba.png";